import { OwaDate, differenceInMinutes } from 'owa-datetime';

/**
 * Interface for GridLine object
 * Created a object as later lines can have types.
 */
interface GridLine {
    top: number;
    key: string;
}

/**
 * Utility to return grid lines
 * @param gridStartTime Start time of the grid
 * @param gridEndTime End time of the grid
 * @param lineStartTime Start time of the line
 * @param repeatLinesPerMin Duration of minutes between lines
 */
export default function getGridLines(
    gridStartTime: OwaDate,
    gridEndTime: OwaDate,
    lineStartTime: OwaDate,
    repeatLinesPerMin: number
): GridLine[] {
    const gridLines = [];
    let currentLinePosition = differenceInMinutes(lineStartTime, gridStartTime);
    const gridEndPosition = differenceInMinutes(gridEndTime, gridStartTime);

    while (currentLinePosition <= gridEndPosition) {
        const line: GridLine = {
            top: currentLinePosition,
            key: `line_${currentLinePosition}`,
        };
        gridLines.push(line);
        currentLinePosition = currentLinePosition + repeatLinesPerMin;
    }

    return gridLines;
}
